<div class="stage-container">
   <div class="stage-background"></div>
   <div class="stage-content">
      <div class="stagecolumns" fxLayout="column" fxFlex="1 1 auto" style="height: 100%">
         <div fxLayout="row" fxFlex="1 1 100">
            <div class="ʎʇɹɐd" *ngIf="showParty$ | async"></div>
            <div class="ʎʇɹɐd" *ngIf="showParty$ | async"></div>
            <div class="ʎʇɹɐd" *ngIf="showParty$ | async"></div>
            <div class="ʎʇɹɐd" *ngIf="showParty$ | async"></div>
            <div class="ʎʇɹɐd" *ngIf="showParty$ | async"></div>
            <div class="ʎʇɹɐd" *ngIf="showParty$ | async"></div>
            <div class="ʎʇɹɐd" *ngIf="showParty$ | async"></div>
            <div class="ʎʇɹɐd" *ngIf="showParty$ | async"></div>
            <div class="ʎʇɹɐd" *ngIf="showParty$ | async"></div>
            <div class="ʎʇɹɐd" *ngIf="showParty$ | async"></div>
            <samweb-stage-line-a
               [brickInstanceId]="brickInstanceId"
               fxFlex="1 1 34"
               fxLayout="row"
            ></samweb-stage-line-a>
            <div fxFlex="1 1 1" style="position: relative; top: 50%; z-index: 1">
               <div
                  *ngIf="!(isCallInProgress$ | async) && !(isLineAIdle$ | async)"
                  [class.dot-pulse]="(callDirection$ | async) === 1"
               ></div>
               <div class="dot-flashing" *ngIf="(isCallInProgress$ | async) && !(isLineAOnHold$ | async)"></div>
            </div>
            <div class="agent-column" fxFlex="1 1 30" fxLayout="column">
               <div
                  class="bg-wrapper"
                  fxLayout="column"
                  fxFlex="auto"
                  [class.bg-wrapper-80]="hasActions$ | async"
                  [class.bg-wrapper-100]="!(hasActions$ | async)"
               >
                  <div
                     class="bg"
                     [style.background-image]="
                        avatarBackgroundStyle === '' || (showCreature$ | async) || (showDefaultBackground$ | async)
                           ? ''
                           : avatarBackgroundStyle
                     "
                  ></div>
               </div>
               <div class="info" fxLayout="column" fxFlex="auto">
                  <div fxFlex="1 1 10">
                     <samweb-recording *ngIf="isRecordingOrError$ | async"></samweb-recording>
                  </div>
                  <div fxFlex="1 1 60" class="ava">
                     <div class="grid container">
                        <div class="state-duration grid-1-1" [samwebUserStatusClass]="currentUserStatusInfo$ | async">
                           <div
                              style="display: fit-content"
                              samwebAutoFitFontSize
                              *ngIf="!(isLineAIdle$ | async) && (waitingSince$ | async) && !(connectedSince$ | async)"
                              [ngClass]="{
                                 waiting:
                                    !(isLineAIdle$ | async) && (waitingSince$ | async) && !(connectedSince$ | async),
                                 'call-waiting': !(isLineAIdle$ | async) && (connectedSince$ | async)
                              }"
                           >
                              {{ waitingSince$ | amTimeAgoUpdateEverySecond$ | durationToText$ | async }}
                           </div>
                           <div
                              style="display: fit-content"
                              samwebAutoFitFontSize
                              class="connected"
                              *ngIf="!(isLineAIdle$ | async) && (connectedSince$ | async)"
                              [ngClass]="{ 'call-connected': !(isLineAIdle$ | async) && (connectedSince$ | async) }"
                           >
                              {{ connectedSince$ | amTimeAgoUpdateEverySecond$ | durationToText$ | async }}
                           </div>
                           <div
                              samwebAutoFitFontSize
                              *ngIf="currentUserStatusDuration$ | async | amIsAfter: (now$ | async)"
                           >
                              {{ currentUserStatusDuration$ | amTimeAgoUpdateEverySecond$ | durationToText$ | async }}
                           </div>
                        </div>
                        <div class="grid-1-1">
                           <samweb-avatar
                              *ngIf="!(showCreature$ | async)"
                              [useSamwinShape]="false"
                              [useRoundShape]="true"
                              [showPresenceStatus]="true"
                              (avatarBackgroundStyleChanged)="avatarBackgroundStyleChangedHandler($event)"
                              fxFlex="1 1 100"
                           >
                           </samweb-avatar>

                           <div class="snc-stage-creature" *ngIf="showCreature$ | async">
                              <figure
                                 class="snc-stage-creature"
                                 [samwebUserStatusClass]="currentUserStatusInfo$ | async"
                                 [ngClass]="{
                                    'snc-stage-creature-zorro': showZorro$ | async,
                                    'snc-stage-creature-sporty': showSporty$ | async,
                                    'snc-stage-creature-beard': showBeard$ | async,
                                    'snc-stage-creature-ninja': showNinja$ | async
                                 }"
                              >
                                 <div class="snc-stage-creature-eye-patch-cord" *ngIf="showPirate$ | async"></div>
                                 <div
                                    class="snc-stage-creature-eye"
                                    [ngClass]="(showPirate$ | async) ? 'snc-stage-creature-eye-patch' : ''"
                                 ></div>
                                 <div class="snc-stage-creature-eye"></div>
                                 <div
                                    class="snc-stage-creature-mouth"
                                    [class.snc-stage-creature-teeth]="(showTeeth$ | async) && !(showPirate$ | async)"
                                    [class.snc-stage-creature-pirate-teeth]="
                                       (showTeeth$ | async) && (showPirate$ | async)
                                    "
                                 ></div>
                              </figure>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div fxFlex="1 1 30" class="agent-info">
                     <div fxLayout="column">
                        <div class="agent-name">{{ userFullName$ | async }}</div>
                        <div class="agent-number">{{ userDn$ | async }}</div>
                     </div>
                  </div>
               </div>
               <samweb-toolbar
                  fxFlex="1 1 20"
                  [brickInstanceId]="brickInstanceId"
                  [toolbarId]="'toolbar'"
                  *ngIf="hasActions$ | async"
               ></samweb-toolbar>
            </div>
            <div fxFlex="1 1 1" style="position: relative; top: 50%">
               <div
                  class="dot-pulse"
                  style="margin-top: -75%"
                  *ngIf="!(canToggleHoldLineB$ | async) && !(isLineBIdle$ | async)"
               ></div>
               <div class="dot-flashing" *ngIf="(canToggleHoldLineB$ | async) && !(isLineBOnHold$ | async)"></div>
            </div>
            <samweb-stage-line-b fxFlex="1 1 34" fxLayout="row"></samweb-stage-line-b>
            <samweb-next-dial-target
               *ngIf="(featureEnabled$ | async) && (showNextDialTarget$ | async) && (isLineBIdle$ | async)"
               [ngClass]="(isLineAIdle$ | async) ? 'line-a' : 'line-b'"
            ></samweb-next-dial-target>
         </div>
      </div>
   </div>
</div>
